/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import ErrorAlert from "../../../others/ErrorAlert";
import { getEntetComm } from "../../../services/clients/ClientApi";
import { updateCommande } from "../../../services/Notification/notificationApi";
import { jsUcfirst } from "../../../utils/Verif";
import { useTranslation } from "react-i18next";
import n2words from "rosaenlg-n2words";
import Loader from "../../../components/shared/Loader";

export default function ModificationCommande() {
  let { code } = useParams();
  const language = Cookies.get("locale");
  const history = useHistory();
  const [t, i18n] = useTranslation("global");

  const [data, setData] = useState({});
  const [lignes, setLignes] = useState([]);
  const [paiement, setPaiement] = useState({});
  const [loading, setLoading] = useState(true);
  const [error] = useState(false);

  // --------------------------------------------------
  //                 LOAD COMMAND BY CODE
  // --------------------------------------------------
  useEffect(() => {
    if (code !== null) {
      getEntetComm(code)
        .then((res) => {
          if (res?.data != null) {
            setPaiement(res.data.paiements[0]);
            setLignes(res.data.lignes);
            setData(res.data);
            setLoading(false);
          }
        })
        .catch((err) => console.log(err));
    }
  }, []);

  // --------------------------------------------------
  //             UPDATE LINE + RECALCUL
  // --------------------------------------------------
  const updateLine = (index, field, value) => {
    const rows = [...lignes];
    rows[index][field] = value;

    let pu = parseFloat(rows[index].pu_ttc) || 0;
    let qte = parseFloat(rows[index].quantite) || 0;
    let remise = parseFloat(rows[index].remise) || 0;

    const total = pu * qte;
    rows[index].total = total.toFixed(3);

    const total_net = total - (total * remise) / 100;
    rows[index].total_net = total_net.toFixed(3);

    setLignes(rows);
    updateTotals(rows);
  };

  // --------------------------------------------------
  //         RECALCUL TOTAL GLOBAL (TTC + REMISE + NET)
  // --------------------------------------------------
const updateTotals = (rows) => {
  let totalTTC = 0;
  let totalNet = 0;
  let totalRemise = 0;

  rows.forEach((l) => {
    const total = parseFloat(l.total) || 0;
    const remisePourcent = parseFloat(l.remise) || 0;

    // 🔥 Montant remise = total * (remise/100)
    const montantRemise = total * (remisePourcent / 100);

    totalTTC += total;
    totalNet += parseFloat(l.total_net) || 0;
    totalRemise += montantRemise;
  });

  setData((prev) => ({
    ...prev,
    montant_total_ttc: totalTTC.toFixed(3),
    net_a_payer: totalNet.toFixed(3),
    total_remise: totalRemise.toFixed(3), // 🔥 Montant réel, pas %
  }));
};


  // --------------------------------------------------
//       VALIDER LES MODIFICATIONS
// --------------------------------------------------
const handleValider = () => {

    // Vérification basique
    if (!lignes || lignes.length === 0) {
        toast(t('messages.aucuneligne'), { position: "bottom-center", type: "warning" });
        return;
    }

    const formData = new FormData();

    // ----------------------------
    //   LIGNES prod[index][...]
    // ----------------------------
    lignes.forEach((item, index) => {
        formData.append(`prod[${index}][id]`, item.id);
        formData.append(`prod[${index}][quantite]`, item.quantite);
        formData.append(`prod[${index}][quantite_facture]`, item.quantite);
        formData.append(`prod[${index}][quantite_commande]`, item.quantite);
        formData.append(`prod[${index}][type]`, 'commande');
        formData.append(`prod[${index}][produit_code]`, item.produit_code);
        formData.append(`prod[${index}][entetecommercial_code]`, item.entetecommercial_code);
        formData.append(`prod[${index}][produit_libelle]`, item.produit_libelle);
        formData.append(`prod[${index}][pu_ttc]`, item.pu_ttc);
        formData.append(`prod[${index}][pu_ht]`, item.pu_ht);
        formData.append(`prod[${index}][remise]`, item.remise);
        formData.append(`prod[${index}][stock]`, 0);
        formData.append(`prod[${index}][colisage]`, item.colisage);
        formData.append(`prod[${index}][ordre]`, item.ordre);
        formData.append(`prod[${index}][total]`, item.total);
        formData.append(`prod[${index}][total_net]`, item.total_net);
    });

    // ----------------------------
    //        Données globales
    // ----------------------------
    formData.append("code", data.code);
    formData.append("client_code", data.client_code);
    formData.append("commercial_code", data.commercial_code);
    formData.append("commercial", data.commercial_code);
    formData.append("soussociete_code", data.soussociete_code);
    formData.append("date_prevu_livraison", data.date_prevu_livraison);
    formData.append("date", data.date);
    formData.append("remiseEspece", data.remiseEspece ?? 0);
    formData.append("montant_total_ttc", data.montant_total_ttc);
    formData.append("net_a_payer", data.net_a_payer);
    formData.append("total_remise", data.total_remise);
    formData.append("envoi", "oui");

    // ----------------------------
    //  APPEL API — COMME addClient
    // ----------------------------
    updateCommande(formData)
        .then((result) => {

            if (result.data.success === false) {
                toast(t('messages.erreurupdate'), { 
                    position: "bottom-center", 
                    type: "error" 
                });
            } else if (result.data.success === true) {
                toast(t('messages.commandeModifiee'), { 
                    position: "bottom-center", 
                    type: "success" 
                });
                history.push("/liste_commandes");
            }
        })
        .catch((err) => {
            console.log(err);
            toast(t('messages.erreurupdate'), { 
                position: "bottom-center", 
                type: "error" 
            });
        });
};


  const sumRemise = () =>
    lignes.reduce((tot, { remise }) => tot + parseFloat(remise), 0);

  // --------------------------------------------------
  //                     RENDER UI
  // --------------------------------------------------
  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          {/* BOUTON RETOUR */}
          <div className="section-title">
            <button className="btn bg-primary" onClick={() => history.goBack()}>
              <i className="fe fe-arrow-left" /> {t("stock.retour")}
            </button>
          </div>

          {/* TITRE */}
          <div className="card">
            <div className="card-header">
              <h3 className="card-title" style={{ paddingTop: "10px" }}>
                {code} — {t("releve.le")} : {data?.date}
              </h3>
            </div>

            <div className="card-body">
              {/* ---------------------------------------------------- */}
              {/*        PARTIE SOCIÉTÉ + CLIENT (RESPONSIVE)          */}
              {/* ---------------------------------------------------- */}
              <div className="row mb-4">

                {/* SOCIETE */}
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                  <p className="h4">
                    {jsUcfirst(data?.societe?.nom || "")}
                  </p>

                  <address className="fs-15" dir={i18n.dir("")}>
                    {t("releve.adresse")} : {data?.societe?.adresse} <br />
                    {t("releve.mf")} : {data?.societe?.matricule_fiscale} <br />
                    {t("releve.tel")} : {data?.societe?.telephone} <br />
                    {t("releve.fax")} : {data?.societe?.fax} <br />
                    {t("login.email")} : {data?.societe?.email}
                  </address>
                </div>

                {/* CLIENT */}
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 text-lg-right text-md-right text-sm-left text-left">
                  <p className="h4">
                    {t("releve.client")} : {data?.client?.nom}{" "}
                    {data?.client?.prenom}
                  </p>

                  <address className="fs-15" dir={i18n.dir("")}>
                    {t("releve.Magasin")} : {data?.client?.magasin} <br />
                    {t("releve.adresse")} : {data?.client?.adresse_facturation}{" "}
                    <br />
                    {t("stock.code")} : {data?.client?.code} <br />
                    {t("detailClient.type")} : {data?.client?.activite} <br />
                    {t("detailClient.mobile")} : {data?.client?.mobile} <br />
                    {t("releve.mf")} : {data?.client?.matricule_fiscale}
                  </address>
                </div>
              </div>

              {/* ---------------------------------------------------- */}
              {/*       TABLEAU RESPONSIVE + MODIFICATION LIGNES       */}
              {/* ---------------------------------------------------- */}
              <div
                className="table-responsive"
                style={{ overflowX: "auto", marginBottom: "20px" }}
              >
                <table className="table table-bordered table-striped table-hover">
                  <thead>
                    <tr className="text-center">
                      <th style={{ minWidth: "60px" }}>{t("releve.num")}</th>
                      <th style={{ minWidth: "120px" }}>{t("releve.ref")}</th>
                      <th style={{ minWidth: "200px" }}>
                        {t("releve.produit")}
                      </th>
                      <th style={{ minWidth: "120px" }}>{t("stock.prix")}</th>
                      <th style={{ minWidth: "110px" }}>{t("stock.qte")}</th>
                      <th style={{ minWidth: "130px" }}>{t("stock.total")}</th>
                      <th style={{ minWidth: "130px" }}>
                        {t("releve.remise")} (%)
                      </th>
                      <th style={{ minWidth: "140px" }}>
                        {t("stock.totalchiffre")}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {lignes.map((items, index) => (
                      <tr key={index} className="text-center">

                        <td>{index + 1}</td>
                        <td>{items.produit_code}</td>

                        <td style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                          {items.produit_libelle}
                        </td>

                        {/* PRIX */}
                        <td>
                          <input
                            type="number"
                            step="0.001"
                            className="form-control text-center p-1"
                            value={items.pu_ttc}
                            onChange={(e) =>
                              updateLine(index, "pu_ttc", e.target.value)
                            }
                          />
                        </td>

                        {/* QUANTITE */}
                        <td>
                          <input
                            type="number"
                            step="1"
                            className="form-control text-center p-1"
                            value={items.quantite}
                            onChange={(e) =>
                              updateLine(index, "quantite", e.target.value)
                            }
                          />
                        </td>

                        {/* TOTAL */}
                        <td>{parseFloat(items.total).toFixed(3)}</td>

                        {/* REMISE */}
                        <td>
                          <input
                            type="number"
                            step="0.1"
                            className="form-control text-center p-1"
                            value={items.remise}
                            onChange={(e) =>
                              updateLine(index, "remise", e.target.value)
                            }
                          />
                        </td>

                        {/* TOTAL NET */}
                        <td>{parseFloat(items.total_net).toFixed(3)}</td>
                      </tr>
                    ))}

                    {/* TOTALS */}
                    <tr>
                      <td colSpan="7" className="text-right">
                        {t("releve.totalttc")}
                      </td>
                      <td className="text-right">
                        {data.montant_total_ttc}
                      </td>
                    </tr>

                    {sumRemise() !== 0 && (
                      <tr>
                        <td colSpan="7" className="text-right">
                          {t("todayCommercial.totalremise")}
                        </td>
                        <td className="text-right">
                          {data.total_remise}
                        </td>
                      </tr>
                    )}

                    <tr>
                      <td colSpan="7" className="text-right">
                        {t("releve.netapayer")}
                      </td>
                      <td className="text-right">
                        {data.net_a_payer}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* ---------------------------------------------------- */}
              {/*           TEXTE MONTANT EN LETTRES                   */}
              {/* ---------------------------------------------------- */}
              <h6 className="text-muted text-center">
                {t("releve.textfacture")} :
                <p className="mb-0 fs-16">
                  {n2words(parseFloat(data?.net_a_payer), {
                    lang: language === "ar" ? "ar" : "fr",
                  })}
                </p>
              </h6>

              <div className="text-center mt-4 mb-3">
                <button
                  className="btn btn-success btn-lg"
                  onClick={handleValider}
                  style={{ minWidth: "220px" }}
                >
                  <i className="fe fe-check-circle" /> {t("releve.transfomer_en_bon_de_livraison")}
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {error && <ErrorAlert t={t} />}
    </div>
  );
}
